import { MecProduct } from '@adapters/bigcommerce/types/product';

export type AttributeType = 'name' | 'price' | 'rating' | 'techspec';

const NAME_KEYS = ['Name', 'Nom'];
const PRICE_KEYS = ['Price', 'Prix'];
const RATING_KEYS = ['Rating', 'Évaluations'];

export function getAttributeType(specKey: string): AttributeType {
  if (NAME_KEYS.includes(specKey)) return 'name';
  if (PRICE_KEYS.includes(specKey)) return 'price';
  if (RATING_KEYS.includes(specKey)) return 'rating';
  return 'techspec';
}

export function getTechSpecValue(
  product: MecProduct,
  specKey: string
): string | null {
  const spec = product.techSpecs.find((s) => s.key === specKey);
  const val = spec?.value;
  if (!val || val === '0' || val === '') return null;
  return Array.isArray(val) ? val.join(', ') : val;
}

export function getTechSpecArray(
  product: MecProduct,
  specKey: string
): string[] | null {
  const spec = product.techSpecs.find((s) => s.key === specKey);
  const val = spec?.value;
  if (!val) return null;
  const items = Array.isArray(val) ? val : [val];
  return items.length > 0 ? items : null;
}

export function formatList(items: string[], conjunction: string): string {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} ${conjunction} ${items[1]}`;
  return `${items.slice(0, -1).join(', ')} ${conjunction} ${
    items[items.length - 1]
  }`;
}
